import { UserRole, UserRoles } from '../types/userRoles'

export const allAuthorities: UserRole[] = [UserRoles.OWNER, UserRoles.ADMIN, UserRoles.MANAGER, UserRoles.WAITER]

export const isAuthorized = (role: UserRole) => {
  return allAuthorities.includes(role)
}

export const isOwner = (role: UserRole) => {
  return role === UserRoles.OWNER
}

export const isAdmin = (role: UserRole) => {
  return role === UserRoles.ADMIN
}

export const isManager = (role: UserRole) => {
  return role === UserRoles.MANAGER
}

export const isWaiter = (role: UserRole) => {
  return role === UserRoles.WAITER
}

export const isManagerLike = (role: UserRole | null | undefined) => {
  if (!role) return false
  return role === UserRoles.MANAGER || role === UserRoles.WAITER
}

export const isPrivelegedUser = (role: UserRole | null | undefined) => {
  if (!role) return false
  return role === UserRoles.OWNER || role === UserRoles.ADMIN || role === UserRoles.MANAGER || role === UserRoles.WAITER
}
